import { CodedItem, HTLActionProvider, SiteV2ConfigMap } from '@types'

export const authRoles = {
  SA: ['SA'], // Only Super Admin has access
  ADMIN: ['SA', 'ADMIN'], // Only SA & Admin has access
  CLIENT_ADMIN: ['SA', 'ADMIN', 'CLIENT_ADMIN'], // ...
  CLIENT: ['SA', 'ADMIN', 'CLIENT_ADMIN', 'CLIENT'],
}

export const chartsColors = [
  '#2e3f50', //
  '#bc5c5c',
  '#bc9f5c',
  '#8fbc5c',
  '#5cb6bc',
  '#5c8abc',
  '#5c63bc',
  '#9e5cbc',
  '#bc5c8c',
  '#bc5c5c',
]

export const modules = {
  SITE: 'MediaSite',
  TRACKER: 'MediaTracker',
  BLOG: 'MediaBlog',
  PUSH: 'MediaPush',
  INVESTOR: 'MediaInvestor',
  OWNER: 'MediaOwner',
}

export const MEDIABOT_IFRAME_URL = 'https://mediabot.mediacore.app/'

export const routes = {
  core: {
    404: `/404/`,
    dev404: `/dev-404-page/`,
    html404: `/404.html`,
    root: `/`,
    change_password: `/cambiar_contrasena/`,
    my_profile: `/mi_perfil/`,
    login: `/sesion/inicio/`,
    custom_login: (loginPath: string) => `/sesion/inicio/${loginPath}/`,
    users: `/usuarios/`,
    add_user: `/usuarios/nuevo/`,
    edit_user: (id: number) => `/usuarios/editar/${id}/`,
    assign_user_permissions: (id: number) => `/usuarios/asignar_permisos/${id}/`,
    clients: `/clientes/`,
    add_client: `/clientes/nuevo/`,
    edit_client: (id: number) => `/clientes/editar/${id}/`,
    login_templates: `/configuracion/pantallas_inicio/`,
    add_login_template: `/configuracion/pantallas_inicio/nuevo/`,
    edit_login_template: (id: number) => `/configuracion/pantallas_inicio/editar/${id}/`,
    groups_and_permissions: `/configuracion/grupos_y_permisos/`,
    support_tickets: `/tickets_soporte/`,
    add_support_ticket: `/tickets_soporte/nuevo`,
    edit_support_ticket: (id: number) => `/tickets_soporte/${id}`,
    guides: `/instructivos/`,
    add_guide: `/instructivos/nuevo/`,
    edit_guide: (id: number) => `/instructivos/editar/${id}/`,
    view_guides: `/instructivos_visor/`,
  },
  site: {
    my_website: `/mediasite/misitioweb/`,
    my_website_v2: `/mediasite/mi_sitio_web_v2/`,
    site_compiler: `/mediasite/compilador_de_sitios_web/`,
    dns: `/mediasite/dns/`,
    published_sites: `/mediasite/sitiospublicados/`,
    fonts: `/mediasite/fuentes/`,
    add_font: `/mediasite/fuentes/nuevo/`,
    edit_font: (id: number) => `/mediasite/fuentes/editar/${id}/`,
    templates: `/mediasite/templates/`,
    add_template: `/mediasite/templates/nuevo/`,
    edit_template: (id: number) => `/mediasite/templates/editar/${id}/`,
    template_categories: `/mediasite/templates/categorias/`,
    add_template_category: `/mediasite/templates/categorias/nuevo/`,
    edit_template_category: (id: number) => `/mediasite/templates/categorias/editar/${id}/`,
    products: `/mediasite/productos/`,
    add_product: `/mediasite/productos/nuevo/`,
    edit_property: (id: number) => `/mediasite/propiedades/editar/${id}/`,
    edit_development: (id: number) => `/mediasite/emprendimientos/editar/${id}/`,
    contacts: `/mediasite/contactos/`,
    preview_contact: (id: number) => `/mediasite/contactos/contacto/${id}/`,
  },
  blog: {
    news: `/mediablog/novedades/`,
    add_news: `/mediablog/novedades/nuevo/`,
    edit_news: (id: number) => `/mediablog/novedades/editar/${id}/`,
    tags: `/mediablog/tags/`,
    add_tags: `/mediablog/tags/nuevo/`,
    edit_tag: (id: number) => `/mediablog/tags/editar/${id}/`,
    preview_news: (id: number) => `/mediablog/novedades/previsualizar/${id}/`,
  },
  push: {
    actions: `/mediapush/destaques/`, //
    add_action: `/mediapush/destaques/nuevo/`,
    edit_action: (id: number) => `/mediapush/destaques/editar/${id}/`,
  },
  tracker: {
    analytics: `/mediatracker/analiticas/`, //
    realtime_analytics: `/mediatracker/analiticastiemporeal/`,
    external_analytics: `/mediatracker/analiticasexternas/`,
    objectives_analytics: `/mediatracker/analiticasobjetivos/`,
    blog_analytics: `/mediatracker/analiticasblog/`,
    push_analytics: `/mediatracker/analiticaspush/`,
    performance_analytics: `/mediatracker/performancegeneral/`,
  },
  investor: {
    config: `/mediainvestor/configuracion/`,
    investors: `/mediainvestor/inversores/`,
    edit_investor: (id: number) => `/mediainvestor/inversores/editar/${id}/`,
    developments: `/mediainvestor/emprendimientos/`,
    add_development: `/mediainvestor/emprendimientos/nuevo/`,
    edit_development: (id: number) => `/mediainvestor/emprendimientos/editar/${id}/`,
    assign_development: (id: number) => `/mediainvestor/inversores/asignar/${id}/`,
    news: `/mediainvestor/novedades/`,
    add_news: `/mediainvestor/novedades/nuevo/`,
    edit_news: (id: number) => `/mediainvestor/novedades/editar/${id}/`,
    preview_news: (id: number) => `/mediainvestor/novedades/previsualizar/${id}/`,
  },
  owner: {
    communications: `/mediaowner/comunicaciones/`,
    add_communication: `/mediaowner/comunicaciones/nuevo/`,
    config: `/mediaowner/configuracion/`,
    owners: `/mediaowner/propietarios/`,
    edit_owner: (id: number) => `/mediaowner/propietarios/editar/${id}/`,
    visits: `/mediaowner/visitas/`,
    add_visit: `/mediaowner/visitas/nuevo/`,
    visit_record: (id: number) => `/mediaowner/visitas/registro_visita/${id}/`,
    edit_visit: (id: number) => `/mediaowner/visitas/editar/${id}/`,
    add_news: `/mediaowner/comunicaciones/novedades/nuevo/`,
    edit_news: (id: number) => `/mediaowner/comunicaciones/novedades/editar/${id}/`,
    preview_news: (id: number) => `/mediaowner/comunicaciones/novedades/previsualizar/${id}/`,
    add_report: `/mediaowner/comunicaciones/reportes/nuevo/`,
    edit_report: (id: number) => `/mediaowner/comunicaciones/reportes/editar/${id}/`,
    preview_report: (id: number) => `/mediaowner/comunicaciones/reportes/previsualizar/${id}/`,
    add_appraisal: `/mediaowner/comunicaciones/tasaciones/nuevo/`,
    edit_appraisal: (id: number) => `/mediaowner/comunicaciones/tasaciones/editar/${id}/`,
    preview_appraisal: (id: number) => `/mediaowner/comunicaciones/tasaciones/previsualizar/${id}/`,
    assign_property: (id: number) => `/mediaowner/propietarios/asignar/${id}/`,
  },
  investor_view: {
    communications: `/inversor/comunicaciones/`,
    investor_news_detail: (id: number) => `/inversor/novedades_inversor/${id}/`,
    owner_news_detail: (id: number) => `/inversor/novedades_propietario/${id}/`,
    report_detail: (id: number) => `/inversor/reportes/${id}/`,
    appraisal_detail: (id: number) => `/inversor/tasaciones/${id}/`,
  },
  owner_view: {
    investor_news_detail: (id: number) => `/propietario/novedades_inversor/${id}/`,
    owner_news_detail: (id: number) => `/propietario/novedades_propietario/${id}/`,
    report_detail: (id: number) => `/propietario/reportes/${id}/`,
    appraisal_detail: (id: number) => `/propietario/tasaciones/${id}/`,
    visit_detail: (id: number) => `/propietario/reportes/tus_visitas/${id}/`,
    communications: `/propietario/comunicaciones/`,
  },
  jobs: {
    positions: `/mediajobs/posiciones`,
    add_position: `/mediajobs/posiciones/nuevo/`,
    edit_position: (id: number) => `/mediajobs/posiciones/editar/${id}`,
    applications: `/mediajobs/candidatos`,
    edit_application: (id: number) => `/mediajobs/candidatos/editar/${id}`,
  },
  marketing_htl: {
    roadmaps: `/mediamarketing/planificacion/`,
    tasks: `/mediamarketing_htl/tareas/`,
    tasks_expanded: `/mediamarketing_htl/tareas_expandidas/`,
    objectives: `/mediamarketing_htl/objetivos/`,
    add_task: `/mediamarketing_htl/tareas/nuevo/`,
    edit_task: (id: number) => `/mediamarketing_htl/tareas/editar/${id}`,
    preview_task: (id: number) => `/mediamarketing_htl/tareas/previsualizar/${id}`,
  },
  control: {
    tickets: `/mediacontrol/tickets/`,
    add_ticket: `/mediacontrol/tickets/nuevo/`,
    edit_ticket: (id: number) => `/mediacontrol/tickets/editar/${id}`,
  },
  bot: `/mediabot/`,
}

export const currency_options = [
  {
    value: 'USD',
    label: 'USD (Dólares estadounidenses)',
  },
  {
    value: 'ARS', //
    label: 'ARS (pesos Argentinos)',
  },
]

export const operation_types = ['Venta', 'Alquiler', 'Temporario']

export const appraisal_property_types = [
  'Departamento', //
  'Casa',
  'PH',
  'Oficina',
  'Local',
  'Cochera',
  'Terreno',
  'Otro',
]

export const property_types = [
  'Departamento', //
  'Casa',
  'PH',
  'Oficina',
  'Local',
  'Cochera',
  'Terreno',
  'Quinta',
  'Depósito',
  'Campo',
  'Edificio comercial',
  'Otro',
]
export const development_property_types = [
  'Edificio residencial', //
  'Edificio de oficinas',
  'Edificio mixto',
  'Hotel',
  'Club',
  'Centro logístico',
  'Loteo',
  'Barrio privado',
  'Rural',
  'Náutico',
  'Centro comercial',
  'Otro',
]

export const parking_lot_options = [
  'Privada cubierta',
  'Privada descubierta',
  'Privada semicubierta',
  'Sin especificar',
]

export const age_options = [
  'En construcción', //
  'A estrenar',
  '1 a 5 años',
  '6 a 10 años',
  '11 a 20 años',
  '21 a 50 años',
  'Más de 50 años',
  'Sin especificar',
]

export const ageToString = (age: number) => {
  switch (true) {
    case age < 0:
      return age_options[0]
    case age === 0:
      return age_options[1]
    case age <= 5 && age > 0:
      return age_options[2]
    case age <= 10 && age > 5:
      return age_options[3]
    case age <= 20 && age > 10:
      return age_options[4]
    case age <= 50 && age > 20:
      return age_options[5]
    case age > 50:
      return age_options[6]
    default:
      return undefined
  }
}

export const orientation_options = [
  'Sur', //
  'Norte',
  'Este',
  'Oeste',
  'Noreste',
  'Sudeste',
  'Noroeste',
  'Suroeste',
  'Sin especificar',
]
export const disposition_options = [
  'Frente', //
  'Contrafrente',
  'Lateral',
  'Interno',
  'Sin especificar',
]
export const luminosity_options = ['Poco luminoso', 'Luminoso', 'Muy luminoso', 'Sin especificar']
export const preservation_state_options = [
  'Mal estado',
  'Estado regular',
  'Buen estado',
  'Excelente estado',
  'Sin especificar',
]
export const building_quality_options = [
  'Baja calidad',
  'Calidad promedio',
  'Buena calidad',
  'Excelente calidad',
  'Sin especificar',
]

export const zonification_options = [
  'APH',
  'ARE',
  'C1',
  'C2',
  'C3 I',
  'C3 II',
  'E1',
  'E2',
  'E3',
  'E4',
  'I1',
  'I2',
  'NE',
  'P',
  'R1a',
  'R1bI',
  'R1bII',
  'R2aI',
  'R2aII',
  'R2bI',
  'R2bII',
  'R2bIII',
  'RU',
  'RUA',
  'U',
  'UF',
  'UP',
  'UP/APH 2',
]
export const region_options = ['Norte', 'Sur', 'Este', 'Oeste']

export const construction_types_options = ['Residencial', 'Comercial', 'Industrial', 'Mixta', 'Otro']

export const growth_rate_options = ['Sin especificar', 'Decreciente', 'Estable', 'Creciente', 'Acelerado']

export const location_quality_options = ['Sin especificar', 'Mala', 'Regular', 'Buena', 'Excelente']

export const security_options = ['Sin especificar', 'Baja', 'Regular', 'Alta', 'Máxima']

export const supply_options = ['Sin especificar', 'Escasa', 'Moderada', 'Abundante', 'Sobre oferta']

export const demand_options = ['Sin especificar', 'Inexistente', 'Escasa', 'Moderada', 'Alta']

export const values_options = ['Sin especificar', 'Decreciente', 'Estable', 'Creciente', 'En alza']

export const surface_measurement_options = ['M2', 'HA']

export const computableTotalSurface = ({
  roofed_surface,
  semiroofed_surface,
  unroofed_surface,
}: {
  roofed_surface?: number
  semiroofed_surface?: number
  unroofed_surface?: number
}) => (roofed_surface ?? 0) + (semiroofed_surface ?? 0) * 0.5 + (unroofed_surface ?? 0) * 0.3

export const measurement_options = ['M', 'KM']

export const extra_services_options = [
  'Agua Corriente',
  'Electricidad',
  'Gas Natural',
  'Cable',
  'Internet',
  'Teléfono',
  'Pavimento',
  'Cloaca',
]
export const extra_general_options = [
  'Balcón',
  'Baulera',
  'Aire acond.',
  'Alarma',
  'Terraza',
  'Sótano',
  'Jardín',
  'Patio',
  'Vestidor',
  'Apto crédito',
  'Apto prof.',
  'Seguridad',
]
export const extra_amenities_options = [
  'Piscina',
  'Piscina climatizada',
  'Calefacción',
  'Gimnasio',
  'Parrilla',
  'Quincho',
  'SUM',
  'Área deportiva',
  'Área de juegos',
  'Sauna',
  'Solarium',
  'Spa',
  'Laundry',
  'Espacios verdes',
  'Área coworking',
  'Hidromasaje',
  'Bicicletero',
  'Rooftop',
]

export const subdivision_options = ['Piso', 'Subsuelo', 'Nivel', 'Lote', 'Fracción', 'Área']

export const valuation_period_rent_options = ['Mensual', 'Semestral', 'Anual']

export const valuation_period_temporary_rent_options = [
  'Diario',
  'Fin de semana',
  'Semanal',
  'Quincenal',
  'Mensual',
  'Anual',
]
export const construction_status_options = ['Pre-venta', 'En pozo', 'En construcción', 'Terminado']

export const payment_method_options = ['Contado', 'Financiado', 'Flexible']

export const elevators_brand_options = ['Schindler', 'Otis', 'Hyundai', 'Thyssenkrupp', 'Otro']

export const climate_control_options = [
  'Aire acondicionado central',
  'Calefacccion central',
  'Mediante radiadores',
  'Mediante equipos Split frío-calor',
  'Suelo radiante',
  'Otro',
  'Sin especificar',
]

export const fire_detection_system_options = [
  'No posee',
  'Detectores de humo',
  'Detectores de calor',
  'Detectores de llama',
  'Sin especificar',
]

export const fire_extinguishing_system_options = ['Rociadores automáticos', 'Extintores y mangeras', 'Sin especificar']

export const development_extra_services_options = [
  'Agua Corriente',
  'Electricidad',
  'Gas Natural',
  'Cable',
  'Internet',
  'Teléfono',
  'Pavimento',
  'Cloaca',
  'Limpieza',
  'Recolección de residuos',
]
export const development_extra_general_options = [
  'Hall de acceso',
  'Bauleras',
  'Cocheras de cortesía',
  'Accesibilidad',
  'CCTV',
  'Garita de seguridad',
  'Cerco perimetral',
  'Grupo electrógeno',
  'Apto blanqueo',
  'Apto crédito',
  'Apto prof.',
  'Seguridad 24hs',
]
export const development_extra_amenities_options = [
  'Piscina',
  'Piscina climatizada',
  'Bar/Restaurante',
  'Gimnasio',
  'Parrilla',
  'Quincho',
  'SUM',
  'Área deportiva',
  'Área de juegos',
  'Sauna',
  'Solarium',
  'Spa',
  'Laundry',
  'Espacios verdes',
  'Área coworking',
  'Hidromasaje',
  'Bicicletero',
  'Rooftop',
]

export const experience_level_options = [
  { label: 'Sin especificar', value: '' },
  { label: 'Trainee', value: 'Trainee' },
  { label: 'Junior', value: 'Junior' },
  { label: 'Semi-senior', value: 'Semi-senior' },
  { label: 'Senior', value: 'Senior' },
]

export const mode_options = [
  { label: 'Sin especificar', value: '' },
  { label: 'Presencial', value: 'Presencial' },
  { label: 'Remota', value: 'Remota' },
  { label: 'Híbrida', value: 'Híbrida' },
]

export const availability_options = [
  { label: 'Sin especificar', value: '' },
  { label: 'Full-time', value: 'Full-time' },
  { label: 'Part-time', value: 'Part-time' },
]

export const application_status_options = [
  'En revisión',
  'Descartado',
  'Entrevistas',
  'Evaluación',
  'Pre-seleccionado',
  'Negociación',
  'Contratado',
]

export const languages_options = [
  'Inglés',
  'Español',
  'Chino (Mandarín)',
  'Francés',
  'Alemán',
  'Italiano',
  'Japonés',
  'Portugués',
  'Ruso',
  'Árabe',
]

export const language_level_options = [
  'No conoce el idioma',
  'Básico',
  'Conversación',
  'Profesional',
  'Nativo o lengua materna',
]

export const job_interviews_options = ['Presencial', 'Teléfónica', 'Video Llamada', 'Chat']

export const application_status_colors: { [key: string]: string } = {
  'En revisión': '#f89a0f',
  Descartado: '#d83d1d',
  Entrevistas: '#6a2365',
  Evaluación: '#e14a77',
  'Pre-seleccionado': '#1dafe6',
  Negociación: '#236a61',
  Contratado: '#3ba84e',
}

export const contactQueryType = {
  development_query: 'Emprendimiento',
  subscription: 'Newsletter',
  property_query: 'Propiedad',
  appraisal: 'Tasación',
  contact: 'Contacto',
  mediablog: 'MediaBlog',
}

export const contactTypeBreadcrumb = {
  development_query: 'Consulta de un emprendimiento',
  subscription: 'Nuevo suscriptor newsletter',
  property_query: 'Consulta de una propiedad',
  appraisal: 'Solicitud de tasación',
  contact: 'Contacto web',
  mediablog: 'Contacto MediaBlog',
}
export const support_ticket_priority_colors = {
  Urgente: '#f24726',
  Alta: '#fac710',
  Normal: '#a7d5f9',
  Baja: '#bdbbbb',
}

export const support_ticket_status_colors = {
  Pendiente: '#ADADAD',
  'En curso': '#da0063',
  'En espera del cliente': '#F89A0F',
  Finalizado: '#8fd14f',
}

export const support_ticket_areas = ['Técnico', 'Comercial', 'Facturación', 'Marketing', 'Soporte', 'Diseño']

export const uploadButtonLabel = (type: 'file' | 'image') => `buscar ${type === 'image' ? 'imágenes' : 'archivos'}`

export const inquiries_options = ['Referido', 'Teléfono', 'Email', 'Email Marketing', 'Otro']

export const external_websites_inquiries_options = ['ArgenProp', 'ZonaProp', 'MercadoLibre', 'Otro']

export const multimedia_video_options = ['YouTube', 'Vimeo'] as const

export const multimedia_360_tours_options = ['Matterport', 'Hauzd', 'Kuula', 'RoundMe', '360 MagicTour'] as const

export const videoPrefixes = {
  YouTube: 'https://www.youtube.com/watch?v=',
  Vimeo: 'https://vimeo.com/',
  Matterport: 'https://my.matterport.com/show/?m=',
  Hauzd: 'https://hauzd.com/',
  Kuula: 'https://kuula.co/share/collection/',
  RoundMe: 'https://roundme.com/embed/',
  '360 MagicTour': 'https://america.360magictour.com/projects/?project=',
}

export const embedPrefixes = {
  YouTube: 'https://www.youtube.com/embed/',
  Vimeo: 'https://player.vimeo.com/video/',
}

export const mapStyles = [
  {
    stylers: [
      {
        saturation: -0,
      },
    ],
  },
  {
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
    ],
  },
  {
    elementType: 'geometry.fill',
    stylers: [
      {
        lightness: 0,
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'true',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#616161',
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#f5f5f5',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeeeee',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#757575',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e5e5e5',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#c5d3ca',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry.fill',
    stylers: [
      {
        lightness: -25,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#757575',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dadada',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#616161',
      },
    ],
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry.fill',
    stylers: [
      {
        lightness: -35,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry.fill',
    stylers: [
      {
        lightness: -25,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e5e5e5',
      },
    ],
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeeeee',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#c9c9c9',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#c5ced3',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
]

export const contacts_status_colors = {
  Nuevo: '#676767',
  Proveedor: '#0B5394',
  Asignado: '#080808ff',
  Contactado: '#FF7A00',
  Meet: '#3C58D3',
  Propuesta: '#FBBF24',
  Ganado: '#30DF57',
  Perdido: '#FF0000',
  Descartado: '#212121',
}

export const contactTypeTranslations = {
  appraisal: 'tasación',
  development_query: 'emprendimiento',
  subscription: 'newsletter',
  property_query: 'propiedad',
  contact: 'contacto',
  mediablog: 'blog',
  Emprendimiento: 'emprendimiento',
  chatbot: 'chatbot',
}

export const globalContainerProps = {
  container: true,
  spacing: 2,
}

export const defaultButtonLabels = {
  save: 'Guardar desactivada',
  publish: 'Guardar activa',
}

export const resources_status_colors: Record<string, string> = {
  'Sin estado': '#9CA3AF',
  Pendiente: '#6B7280',
  'En curso': '#3B82F6',
  'Esperando aprobación': '#F59E0B',
  Aprobada: '#10B981',
  'En desarrollo': '#8B5CF6',
  'En revisión': '#F97316',
  'Necesita cambios': '#EF4444',
  Completada: '#059669',
  Pausada: '#FF7A00',
  Cancelada: '#DC2626',
}

export const finished_task_statuses = ['Completada', 'Cancelada'] as const

export const resources_legacy_status_colors: Record<string, string> = {
  Pendiente: '#C7C7C7',
  'En curso': '#FFFF00',
  'Revisión Cliente': '#0000FF',
  'Revisión Agencia': '#0000FA',
  'Aprobado por Cliente': '#90EE90',
  'Requiere Modificaciones': '#FFA500',
  'En Pausa': '#FF7A00',
  Finalizado: '#008000',
  Cancelado: '#8B0000',
}

export const HIERARCHY_ROW_BACKGROUNDS = ['#D3D3D3', '#E3E3E3', '#F3F3F3']

export const resource_types = ['TAR - Tarea', 'REL - Relevamiento', 'ENT - Entregable'] as const

export const resource_types_legacy = ['Solicitud', 'Entregable', 'Minuta', 'Informe'] as const

export const resource_survey_tasks: CodedItem[] = [
  { code: 'RIP', label: 'RIP Relevamiento Inicial de Proyecto' },
  { code: 'RLG', label: 'RLG Relevamiento de Lineamientos Generales' },
  { code: 'RIM', label: 'RIM Relevamiento de Identidad Marcaria' },
  { code: 'RIN', label: 'RIN Relevamiento Naming' },
  { code: 'RDG', label: 'RDG Relevamiento Diseño Gráfico' },
  { code: 'RIW', label: 'RIW Relevamiento Sitio Web' },
  { code: 'RLN', label: 'RLN Relevamiento Landing Page' },
  { code: 'RCP', label: 'RCP Relevamiento Campaña Publicitaria' },
  { code: 'REM', label: 'REM Relevamiento Email Marketing' },
  { code: 'RRS', label: 'RRS Relevamiento Redes Sociales' },
  { code: 'RMC', label: 'RMC Relevamiento MediaCore' },
  { code: 'RCO', label: 'RCO Relevamiento Consultoría' },
]

export const resource_deliverable_tasks: CodedItem[] = [
  { code: 'EON', label: 'EON Entregable Onboarding' },
  { code: 'ELG', label: 'ELG Lineamientos Generales' },
  { code: 'ERM', label: 'ERM Reporte Ejecutivo Mensual' },
  { code: 'ERT', label: 'ERT Reporte Trimestral' },
  { code: 'ERC', label: 'ERC Reporte Contingencia' },
  { code: 'EIM', label: 'EIM Manual Marca' },
  { code: 'ENA', label: 'ENA Naming' },
  { code: 'EDG', label: 'EDG Pieza Gráfica' },
  { code: 'EWB', label: 'EWB Prototipo Web' },
  { code: 'ELN', label: 'ELN Landing Page Performance' },
  { code: 'EPV', label: 'EPV Producción Audiovisual' },
  { code: 'EPC', label: 'EPC Reporte PPC' },
  { code: 'EEM', label: 'EEM Email Marketing Mensual' },
  { code: 'ERS', label: 'ERS Piezas Redes Sociales' },
  { code: 'EMC', label: 'EMC Entregable MediaCore' },
  { code: 'ECO', label: 'ECO Informe Consultoría' },
]

export const marketing_task_areas: CodedItem[] = [
  { code: 'SOP', label: 'SOP Soporte' },
  { code: 'DSG', label: 'DSG Diseño Gráfico' },
  { code: 'WEB', label: 'WEB Sitio Web' },
  { code: 'PAV', label: 'PAV Producción Audiovisual' },
  { code: 'PPC', label: 'PPC Publicidad' },
  { code: 'EMM', label: 'EMM Email Marketing' },
  { code: 'COM', label: 'COM Comunicación' },
  { code: 'COR', label: 'COR Mediacore' },
  { code: 'CON', label: 'CON Consultoría' },
]

export const resource_categories: Partial<Record<(typeof resource_types)[number], CodedItem[]>> = {
  'REL - Relevamiento': resource_survey_tasks,
  'ENT - Entregable': resource_deliverable_tasks,
  'TAR - Tarea': [],
}
export const agency_areas_categories = {
  Entregable: {
    Comunicación: [
      'Desarrollo contenidos PPC',
      'Desarrollo contenidos ORG',
      'Desarrollo contenidos Email MKTG',
      'Key visual',
      'Nota blog',
      'Branding',
      'Estrategias de Contenidos',
      'Estrategia de Marca',
      'Lineamientos Generales',
      'Reportes / Informes',
      'Minuta',
      'Varios',
    ],
    Desarrollo: ['Sitio Web', 'Landing Page', 'Pre Landing', 'Prototipo', 'Instructivos', 'Varios'],
    Audiovisual: ['Branding', 'Equipo', 'Producto', 'Testimoniales', 'RRSS', 'Varios'],
    Prensa: [
      'Notas de Prensa',
      'Artículos en Medios',
      'Organización de Eventos',
      'Relaciones con Medios',
      'Conferencias de Prensa',
      'Menciones y Publicaciones',
      'Varios',
    ],
    'Recursos Generales': [
      'Logos',
      'Tipografía',
      'Imágenes',
      'Iconografía',
      'Paleta de Colores',
      'Patrones Gráficos',
      'Manual de Marca',
      'Varios',
    ],
    Reunión: ['Reunión Remota', 'Reunión presencial'],
    'Reunión entendimiento': [
      'Presentación',
      'Foco Agencia',
      'Foco Cliente',
      'Validación lineamientos generales',
      'Validación Pre-Activacion',
      'Validación Pos-Activacion',
      'Reporte Mes',
      'Reporte Q1',
      'Reporte Q2',
      'Reporte Y1',
    ],
  },
}

export const agency_areas_categories_legacy = {
  Solicitud: {},
  Minuta: {},
  Informe: {
    'Email Marketing': [],
    Performance: [],
    'Redes Sociales': ['Facebook', 'Instagram'],
  },
  Entregable: {
    Comunicación: [
      'Desarrollo contenidos PPC',
      'Desarrollo contenidos ORG',
      'Desarrollo contenidos Email MKTG',
      'Key visual',
      'Nota blog',
      'Branding',
      'Estrategias de Contenidos',
      'Estrategia de Marca',
      'Lineamientos Generales',
      'Reportes / Informes',
      'Minuta',
      'Varios',
    ],
    Desarrollo: ['Sitio Web', 'Landing Page', 'Pre Landing', 'Prototipo', 'Instructivos', 'Varios'],
    Audiovisual: ['Branding', 'Equipo', 'Producto', 'Testimoniales', 'RRSS', 'Varios'],
    Prensa: [
      'Notas de Prensa',
      'Artículos en Medios',
      'Organización de Eventos',
      'Relaciones con Medios',
      'Conferencias de Prensa',
      'Menciones y Publicaciones',
      'Varios',
    ],
    'Recursos Generales': [
      'Logos',
      'Tipografía',
      'Imágenes',
      'Iconografía',
      'Paleta de Colores',
      'Patrones Gráficos',
      'Manual de Marca',
      'Varios',
    ],
    Reunión: ['Reunión Remota', 'Reunión presencial'],
    'Reunión entendimiento': [
      'Presentación',
      'Foco Agencia',
      'Foco Cliente',
      'Validación lineamientos generales',
      'Validación Pre-Activacion',
      'Validación Pos-Activacion',
      'Reporte Mes',
      'Reporte Q1',
      'Reporte Q2',
      'Reporte Y1',
    ],
  },
}

export const action_background_type_options = [
  { value: 'image', label: 'Imagen' },
  { value: 'color', label: 'Color' },
]

export const MAX_WEBP_DIMENSION = 2000 // https://developers.google.com/speed/webp/faq?ref=blog.opinly.ai&hl=es-419#what_is_the_maximum_size_a_webp_image_can_be

export const mediacontrol_ticket_areas = ['Marketing', 'Comercial', 'Tecnología', 'Soporte al cliente']

export const mediacontrol_ticket_priority_colors = {
  Crítica: '#f24726',
  Alta: '#fac710',
  Normal: '#a7d5f9',
  Baja: '#bdbbbb',
}

export const medicontrol_ticket_status_colors: Record<string, string> = {
  'Por hacer': '#C7C7C7',
  'En curso': '#FFFF00',
  Validando: '#0000FF',
  'Con ajustes': '#FF7A00',
  'En pausa': '#4B4B4B',
  Aprobado: '#90EE90',
  'Para entregar': '#00008B',
  Finalizado: '#008000',
  Cancelado: '#8B0000',
}

export const COMPONENT_QUICK_GROUPS: Record<string, SiteV2ConfigMap> = {
  title: {
    title: { type: 'string', label: 'Titulo', default_value: '' },
    titleElement: {
      type: 'radio',
      label: 'Elemento del titulo',
      default_value: 'h1',
      options: [
        { label: 'h1', value: 'h1' },
        { label: 'h2', value: 'h2' },
        { label: 'h3', value: 'h3' },
        { label: 'h4', value: 'h4' },
        { label: 'h5', value: 'h5' },
        { label: '', value: '' },
      ],
    },
    titleHexa: { type: 'color', label: 'Color del titulo', default_value: '#383838' },
  },
  subtitle: {
    subtitle: { type: 'string', label: 'Subtitulo', multiline: true, default_value: '' },
    subtitleElement: {
      type: 'radio',
      label: 'Elemento del subtitulo',
      default_value: 'h3',
      options: [
        { label: 'h2', value: 'h2' },
        { label: 'h3', value: 'h3' },
        { label: 'h4', value: 'h4' },
        { label: 'h5', value: 'h5' },
        { label: 'p', value: 'p' },
      ],
    },
    subtitleHexa: { type: 'color', label: 'Color del subtitulo', default_value: '#616161' },
  },
  paragraph: {
    paragraphElement: {
      type: 'radio',
      label: 'Elemento del listado',
      default_value: 'p',
      options: [
        { label: 'h3', value: 'h3' },
        { label: 'h4', value: 'h4' },
        { label: 'h5', value: 'h5' },
        { label: 'p', value: 'p' },
      ],
    },
    paragraphHexa: { type: 'color', label: 'Color del listado', default_value: '#242424' },
  },
  background: {
    backgroundHexa: { type: 'color', label: 'Color del fondo', default_value: '#FFFFFF' },
  },
  alignment: {
    align: {
      type: 'radio',
      label: 'Alineamiento',
      options: [
        {
          label: 'Centro',
          value: 'center',
        },
        {
          label: 'Derecha',
          value: 'right',
        },
        {
          label: 'Izquierda',
          value: 'left',
        },
      ],
      tooltip: '',
      max_items: 0,
      min_items: 0,
      default_value: 'center',
    },
  },
  button: {
    button: {
      type: 'object',
      label: 'Boton',
      tooltip: '',
      max_items: 0,
      min_items: 0,
      item_config: {
        link: {
          type: 'string',
          label: 'Enlace',
          tooltip: '',
          max_items: 0,
          min_items: 0,
          max_length: 0,
          min_length: 0,
          placeholder: '',
          default_value: '',
        },
        value: {
          type: 'string',
          label: 'Texto',
          tooltip: '',
          max_items: 0,
          min_items: 0,
          max_length: 0,
          min_length: 0,
          placeholder: '',
          default_value: '',
        },
        valueColor: {
          type: 'color',
          label: 'Color fuente',
          tooltip: '',
          max_items: 0,
          min_items: 0,
          default_value: '#FFFFFF',
        },
        borderColor: {
          type: 'color',
          label: 'Color borde',
          tooltip: '',
          max_items: 0,
          min_items: 0,
          default_value: '#FFFFFF',
        },
        backgroundColor: {
          type: 'color',
          label: 'Color de fondo',
          tooltip: '',
          max_items: 0,
          min_items: 0,
          default_value: '#FFFFFF',
        },
      },
      default_value: {},
    },
  },
}
export const COMPONENT_GROUP_LABEL: Record<string, string> = {
  title: 'Título',
  subtitle: 'Subtítulo',
  paragraph: 'Párrafo',
  background: 'Fondo',
  alignment: 'Alineación',
  button: 'Botón',
}

export const MKTG_PROFILES: Record<string, string[]> = {
  Inmobiliaria: ['Residencial', 'Corporativo', 'Rural', 'Mixto'],
  Desarrolladora: ['Residencial', 'Corporativo', 'Mixto'],
  'Inmobiliaria Desarrolladora': [
    'Residencial',
    'Corporativo',
    'Rural',
    'Mixto',
    'Portfolio Diversificado',
    'Especialista Dual',
  ],
}

export const HTL_LEVEL = ['Captación', 'Venta', 'Marca', 'Otros']

export const OBJECTIVES: Record<string, Record<string, string[]>> = {
  Inmobiliaria: {
    Captación: [
      'Captación propietarios vendedores ',
      'Captación propietarios locadores ',
      'Captación inversores institucionales ',
      'Captación desarrolladoras comercialización ',
      'Captación clientes compradores activos ',
      'Captación tasaciones sin compromiso ',
    ],
    Venta: [
      'Venta propiedad específica',
      'Alquiler propiedad específica',
      'Venta/alquiler portfolio similares',
      'Venta cruzada distintos segmentos',
    ],
    Marca: [
      'Diferenciación competitiva mercado local',
      'Fortalecimiento confianza institucional',
      ' Generación autoridad referente local',
    ],
  },
  Desarrolladora: {
    Captación: [
      'Captación inversores institucionales',
      'Captación inversores individuales',
      'Captación compradores tempranos pozo',
      'Captación socios comerciales partners',
      'Captación brokers inmobiliarias canal',
      'Captación dueños tierra desarrollos',
    ],
    Venta: [
      'Venta emprendimiento específico',
      'Venta unidades remanentes',
      'Preventa proyecto desarrollo',
      'Lanzamiento nuevo proyecto',
      'Venta portfolio proyectos activos',
      'Venta unidades etapas intermedias',
    ],
    Marca: [
      'Posicionamiento desarrolladora calidad',
      'Construcción track record prestigio',
      'Diferenciación propuesta valor',
      'Fortalecimiento marca corporativa',
      'Posicionamiento marca innovadora/sustentable',
    ],
  },
  'Inmobiliaria Desarrolladora': {
    Captación: [
      'Captación propietarios vendedores',
      'Captación propietarios locadores',
      'Captación inversores institucionales',
      'Captación desarrolladoras comercialización',
      'Captación clientes compradores activos',
      'Captación tasaciones sin compromiso',
      'Captación inversores individuales',
      'Captación compradores tempranos pozo',
      'Captación socios comerciales partners',
      'Captación brokers inmobiliarias canal',
      'Captación dueños tierra desarrollos',
    ],
    Venta: [
      'Venta propiedad específica',
      'Alquiler propiedad específica',
      'Venta / alquiler portfolio similares',
      'Venta cruzada distintos segmentos',
      'Venta emprendimiento específico',
      'Venta unidades remanentes',
      'Preventa proyecto desarrollo',
      'Lanzamiento nuevo proyecto',
      'Venta portfolio proyectos activos',
      'Venta unidades etapas intermedias',
    ],
    Marca: [
      'Diferenciación competitiva mercado local',
      'Fortalecimiento confianza institucional',
      'Generación autoridad referente local',
      'Posicionamiento desarrolladora calidad',
      'Construcción track record prestigio',
      'Diferenciación propuesta valor',
      'Fortalecimiento marca corporativa',
      'Posicionamiento marca innovadora/sustentable',
    ],
  },
}

export type TaskKind = 'REL' | 'ENT'
export type AreaCode = 'SOP' | 'DSG' | 'WEB' | 'PAV' | 'PPC' | 'EMM' | 'RED' | 'COR' | 'CON' | 'COM'

export const ACTION_DETAILS: Record<string, string> = {
  // RELEVAMIENTO
  REG: 'Relevamiento Diseño Gráfico',
  RIM: 'Relevamiento de Identidad Marcaria',
  RIV: 'Relevamiento de Imagen Visual',
  RIW: 'Relevamiento Sitio Web',
  RIL: 'Relevamiento Landing Page',
  RIP: 'Relevamiento Inicial de Proyecto',
  RIE: 'Relevamiento Emprendimientos',
  RCO: 'Relevamiento Consultoría',
  RRC: 'Relevamiento de Comunicación',
  RRM: 'Relevamiento MediaCore',
  RRS: 'Relevamiento Redes Sociales',
  RRP: 'Relevamiento de Publicidades',
  REM: 'Relevamiento Email Marketing',

  // ENTREGABLE
  EON: 'Entregable Onboarding',
  ELG: 'Lineamientos Generales',
  ENA: 'Naming',
  EDG: 'Pieza Gráfica',
  EIM: 'Manual Marca',
  EWB: 'Prototipo Web',
  ELN: 'Landing Page Performance',
  EPV: 'Producción Audiovisual',
  ECO: 'Informe Consultoría',
  ERM: 'Reporte Ejecutivo Mensual',
  ERT: 'Reporte Trimestral',
  ERC: 'Reporte Contingencia',
  ERS: 'Piezas Redes Sociales',
  EMC: 'Entregable MediaCore',
  EEM: 'Email Marketing Mensual',
  RLG: 'Relevamiento de Lineamientos Generales',
  RLN: 'RLN Relevamiento Landing Page',
  RCP: 'RCP Relevamiento Campaña Publicitaria',
  EWF: 'Wireframe',
}

export const ACTIONS_BY_TYPE_AND_AREA: Record<TaskKind, Partial<Record<AreaCode, string[]>>> = {
  REL: {
    SOP: ['RIP', 'RLG'],
    DSG: ['RIM', 'RIN', 'RDG'],
    WEB: ['RIW', 'RLN'],
    PAV: ['RAV'],
    PPC: ['RCP'],
    EMM: ['REM'],
    RED: ['RRS'],
    COR: ['RMC'],
    CON: ['RCO'],
  },
  ENT: {
    SOP: ['EON', 'ELG', 'ERM', 'ERT', 'ERC'],
    DSG: ['EIM', 'EMM', 'ENA', 'EDG'],
    WEB: ['EWB', 'ELN'],
    PAV: ['EPV'],
    PPC: ['ECP'],
    EMM: ['EEM'],
    RED: ['ERS'],
    COR: ['EMC'],
    CON: ['ECO'],
  },
}

const AREA_DEFS: Record<AreaCode, AreaWithCategories> = {
  SOP: { code: 'SOP', label: 'SOP - Soporte', categories: [{ code: 'SOP', label: 'SOP - Soporte' }] },
  // ONB: { code: 'ONB', label: 'ONB - Onboarding', categories: [{ code: 'EON', label: 'EON - Entregable Onboarding' }] },
  DSG: {
    code: 'DSG',
    label: 'DSG - Diseño Gráfico',
    categories: [
      { code: 'REG', label: 'REG - Relevamiento Diseño Gráfico' },
      { code: 'RIM', label: 'RIM - Relevamiento de Identidad Marcaria' },
      { code: 'RIV', label: 'RIV - Relevamiento de Imagen Visual' },
      { code: 'ELG', label: 'ELG - Lineamientos Generales' },
      { code: 'ENA', label: 'ENA - Naming' },
      { code: 'EDG', label: 'EDG - Pieza Gráfica' },
      { code: 'EIM', label: 'EIM - Manual Marca' },
    ],
  },
  WEB: {
    code: 'WEB',
    label: 'WEB - Sitio Web',
    categories: [
      { code: 'RIW', label: 'RIW - Relevamiento Sitio Web' },
      { code: 'RIL', label: 'RIL - Relevamiento Landing Page' },
      { code: 'EWB', label: 'EWB - Prototipo Web' },
      { code: 'ELN', label: 'ELN - Landing Page Performance' },
    ],
  },
  PAV: {
    code: 'PAV',
    label: 'PAV - Producción Audiovisual',
    categories: [
      { code: 'RIP', label: 'RIP - Relevamiento Inicial de Proyecto' },
      { code: 'EPV', label: 'EPV - Producción Audiovisual' },
    ],
  },
  CON: {
    code: 'CON',
    label: 'CON - Consultoría',
    categories: [
      { code: 'RCO', label: 'RCO - Relevamiento Consultoría' },
      { code: 'ECO', label: 'ECO - Informe Consultoría' },
    ],
  },
  COM: {
    code: 'COM',
    label: 'COM - Comunicación',
    categories: [
      { code: 'RRC', label: 'RRC - Relevamiento de Comunicación' },
      { code: 'RRS', label: 'RRS - Relevamiento Redes Sociales' },
      { code: 'ERM', label: 'ERM - Reporte Ejecutivo Mensual' },
      { code: 'ERT', label: 'ERT - Reporte Trimestral' },
      { code: 'ERC', label: 'ERC - Reporte Contingencia' },
      { code: 'ERS', label: 'ERS - Piezas Redes Sociales' },
    ],
  },
  COR: {
    code: 'COR',
    label: 'COR - Mediacore',
    categories: [
      { code: 'RRM', label: 'RRM - Relevamiento MediaCore' },
      { code: 'EMC', label: 'EMC - Entregable MediaCore' },
    ],
  },
  PPC: {
    code: 'PPC',
    label: 'PPC - Publicidad',
    categories: [
      // { code: 'RRP', label: 'RRP - Relevamiento de Publicidades' },
      { code: 'EPC', label: 'EPC - Reporte PPC' },
    ],
  },
  EMM: {
    code: 'EMM',
    label: 'EMM - Email Marketing',
    categories: [
      { code: 'REM', label: 'REM - Relevamiento Email Marketing' },
      { code: 'EEM', label: 'EEM - Email Marketing Mensual' },
    ],
  },
  RED: {
    code: 'RED',
    label: 'RED - Gestión de redes sociales',
    categories: [],
  },
}

const pick = (codes: AreaCode[]) => codes.map((c) => AREA_DEFS[c])
type AreaWithCategories = CodedItem & { categories: CodedItem[] }

export const MKTG_MODES: Record<string, AreaWithCategories[]> = {
  'GOD (Gestión Orgánica Digital)': pick(['SOP', 'DSG', 'WEB', 'PAV', 'RED', 'COR', 'CON', 'COM']),
  'GPD (Gestión Publicitaria Digital)': pick(['SOP', 'DSG', 'WEB', 'PAV', 'PPC', 'COR', 'CON', 'COM']),
  'GMD (Gestión Mailing Digital)': pick(['SOP', 'DSG', 'WEB', 'PAV', 'EMM', 'COR', 'CON', 'COM']),
  'GUP (Gestión Única de Proyecto)': pick(['SOP', 'DSG', 'WEB', 'PAV', 'PPC', 'EMM', 'RED', 'COR', 'CON', 'COM']),
}

type MktgModeKey = keyof typeof MKTG_MODES
type PlatformOption = { value: string; label: string }

const modePlatformValues: Record<
  'GOD (Gestión Orgánica Digital)' | 'GPD (Gestión Publicitaria Digital)' | 'GMD (Gestión Mailing Digital)',
  string[]
> = {
  'GOD (Gestión Orgánica Digital)': ['MediaBlog', 'MediaPush', 'MediaJobs', 'RRSS Linkedin'],
  'GPD (Gestión Publicitaria Digital)': ['Meta Ads', 'Google Ads'],
  'GMD (Gestión Mailing Digital)': ['Email'],
}

const toPlatformOptions = (values: string[]): PlatformOption[] => values.map((value) => ({ value, label: value }))

export const MKTG_PLATFORM_OPTIONS: Record<MktgModeKey, PlatformOption[]> = {
  'GOD (Gestión Orgánica Digital)': toPlatformOptions(modePlatformValues['GOD (Gestión Orgánica Digital)']),
  'GPD (Gestión Publicitaria Digital)': toPlatformOptions(modePlatformValues['GPD (Gestión Publicitaria Digital)']),
  'GMD (Gestión Mailing Digital)': toPlatformOptions(modePlatformValues['GMD (Gestión Mailing Digital)']),
}

export type MarketingTaskIntegrationActionGroup = {
  id: string
  label: string
  color: 'neutral' | 'primary' | 'success' | 'warning' | 'danger' | 'info'
  options: {
    id: string
    label: string
    description?: string
  }[]
}

export const MARKETING_TASK_INTEGRATION_ASSIGNMENT_GROUPS: MarketingTaskIntegrationActionGroup[] = [
  {
    id: 'mediacore',
    label: 'MediaCore',
    color: 'primary',
    options: [
      { id: 'mediacore_push', label: 'Destaque MediaPush' },
      { id: 'mediacore_blog', label: 'Novedad MediaBlog' },
      { id: 'mediacore_jobs', label: 'Posición MediaJobs' },
    ],
  },
  {
    id: 'metricool',
    label: 'Metricool',
    color: 'success',
    options: [
      { id: 'metricool_post_facebook', label: 'Post Facebook' },
      { id: 'metricool_post_instagram', label: 'Post Instagram' },
      { id: 'metricool_post_linkedin', label: 'Post LinkedIn' },
      { id: 'metricool_post_tiktok', label: 'Post TikTok' },
      { id: 'metricool_story_facebook', label: 'Story Facebook' },
      { id: 'metricool_story_instagram', label: 'Story Instagram' },
      { id: 'metricool_ads_meta', label: 'Pauta Meta' },
      { id: 'metricool_ads_google', label: 'Pauta Google' },
    ],
  },
  {
    id: 'mailup',
    label: 'MailUp',
    color: 'warning',
    options: [{ id: 'mailup-newsletter', label: 'Newsletter' }],
  },
]

export const METRICOOL_ENDPOINT_BY_ASSIGNMENT: Partial<Record<HTLActionProvider, string>> = {
  metricool_post_facebook: 'analytics/posts/facebook',
  metricool_post_instagram: 'analytics/posts/instagram',
  metricool_post_linkedin: 'analytics/posts/linkedin',
  metricool_post_tiktok: 'analytics/posts/tiktok',
  metricool_story_facebook: 'analytics/stories/facebook',
  metricool_story_instagram: 'analytics/stories/instagram',
  metricool_ads_meta: 'stats/facebookads/campaigns',
  metricool_ads_google: 'stats/adwords/campaigns',
}

export const MTK_STAGES: Record<string, Record<string, string[]>> = {
  Atracción: {
    'GOD (Gestión Orgánica Digital)': [
      'Artículo tendencias mercado',
      'Guía proceso compra/venta',
      'Análisis precios zonales',
      'Entrevista referente sectorial',
      'Reseña proyecto inmobiliario',
      'Push lanzamiento proyecto',
      'Push oportunidad inversión',
      'Push contenido blog',
      'Push evento sectorial',
      'Publicación educativa',
      'Carrusel consejos',
      'Video testimonial',
      'Historia detrás de escena',
      'Reel tour virtual',
    ],
    'GPD (Gestión Publicitaria Digital)': [
      'Campaña reconocimiento marca',
      'Campaña tráfico blog',
      'Campaña video institucional',
      'Campaña alcance engagement',
      'Campaña remarketing',
      'Campaña búsqueda genérica',
      'Campaña display remarketing',
      'Campaña YouTube institucional',
      'Campaña Discovery audiencias',
      'Campaña Performance Max',
    ],
    'GMD (Gestión Mailing Digital)': [
      'Newsletter mensual',
      'Email bienvenida',
      'Email contenido educativo',
      'Email invitación evento',
      'Email presentación servicios',
    ],
  },
  Consideración: {
    'GOD (Gestión Orgánica Digital)': [
      'Análisis proyecto específico',
      'Caso éxito detallado',
      'Guía financiamiento',
      'Whitepaper mercado',
      'Entrevista CEO',
      'Búsqueda talento',
      'Cultura organizacional',
      'Beneficios sector',
      'Empleado destacado',
      'Capacitación profesional',
      'Carrusel metodología',
      'Video servicios',
      'IGTV entrevista',
      'Historia preguntas respuestas',
      'Live educativo',
    ],
    'GPD (Gestión Publicitaria Digital)': [
      'Campaña conversión descarga',
      'Campaña generación leads',
      'Campaña video testimonial',
      'Campaña catálogo proyectos',
      'Campaña promoción evento',
      'Campaña búsqueda específica',
      'Campaña shopping propiedades',
      'Campaña Gmail segmentada',
      'Campaña YouTube servicios',
      'Campaña promoción app',
    ],
    'GMD (Gestión Mailing Digital)': [
      'Secuencia nutrición',
      'Email caso estudio',
      'Email consulta gratuita',
      'Email contenido premium',
      'Email webinar especializado',
    ],
  },
  Conversión: {
    'GOD (Gestión Orgánica Digital)': [
      'Widget cotización',
      'Formulario tasación',
      'Calculadora financiamiento',
      'Agenda cita',
      'Chatbot consultas',
      'Publicación CTA descarga',
      'Historia swipe consulta',
      'Carrusel CTA cotización',
      'Video CTA suscripción',
      'Live CTA participación',
    ],
    'GPD (Gestión Publicitaria Digital)': [
      'Campaña lead ads',
      'Campaña conversión cita',
      'Campaña mensaje WhatsApp',
      'Campaña conversión premium',
      'Campaña llamada directa',
      'Campaña conversión formulario',
      'Campaña visita local',
      'Campaña instalación app',
      'Campaña Smart Bidding',
    ],
    'GMD (Gestión Mailing Digital)': [
      'Email CTA reunión',
      'Secuencia abandono formulario',
      'Email consulta limitada',
      'Email análisis personalizado',
      'Email visita showroom',
    ],
  },
  Fidelización: {
    'GOD (Gestión Orgánica Digital)': [
      'Portal cliente VIP',
      'Newsletter exclusiva',
      'Alertas personalizadas',
      'Dashboard performance',
      'Sistema referidos',
      'Grupo clientes VIP',
      'Contenido exclusivo',
      'Reconocimiento clientes',
      'Eventos exclusivos',
      'Programa embajadores',
    ],
    'GPD (Gestión Publicitaria Digital)': [
      'Campaña audiencias similares clientes',
      'Campaña venta cruzada',
      'Campaña reactivación',
      'Campaña venta incremental',
      'Campaña advocacy',
      'Campaña RLSA',
      'Campaña Customer Match',
      'Campaña audiencias similares',
      'Campaña expansión servicios',
      'Campaña retención',
    ],
    'GMD (Gestión Mailing Digital)': [
      'Email programa fidelización',
      'Secuencia postventa',
      'Email programa referidos',
      'Newsletter VIP insights',
      'Email encuesta NPS',
    ],
  },
  Todas: {},
}

export type ModeLabel =
  | 'GOD (Gestión Orgánica Digital)'
  | 'GPD (Gestión Publicitaria Digital)'
  | 'GMD (Gestión Mailing Digital)'

export const CONVERSION_CHANNEL: Record<ModeLabel, Record<string, string[]>> = {
  'GOD (Gestión Orgánica Digital)': {
    MediaBlog: [
      'Beneficios contratos exclusividad',
      'Urgencia mercado actual',
      'Ofertas tiempo limitado',
      'Historias éxito recientes',
    ],
    MediaJobs: ['Disponibilidad inmediata consultores', 'Reuniones'],
    MediaPush: [
      'CTA "Tasar Ahora"',
      'Formularios captura optimizados',
      'Botones click-to-call',
      'Calendario reservas integrado',
    ],
    RRSS: [
      'Prueba social reciente',
      'Publicaciones con urgencia',
      'Stories con CTA directo',
      'Botones contacto optimizados',
      'Automatización Messenger',
    ],
  },
  'GPD (Gestión Publicitaria Digital)': {
    Meta: [
      'Campañas conversión con CTAs específicos',
      'Anuncios dinámicos propiedades vendidas',
      'Catálogo casos de éxito',
      'Anuncios Messenger (contacto directo)',
    ],
    Google: [
      'Búsquedas de alta intención',
      'Anuncios solo llamada',
      'Extensiones ubicación/promoción',
      'Seguimiento conversiones optimizado',
    ],
    LinkedIn: [
      'Formularios Lead Gen optimizados',
      'Contenido patrocinado con CTA directo',
      'Message Ads de conversión',
    ],
  },
  'GMD (Gestión Mailing Digital)': {
    Email: [
      'Propuesta automatizada post-llamada',
      'Secuencias envío contrato',
      'Oferta tiempo limitado',
      'Contacto personalizado agente',
      'Flujos confirmación cita/tasación',
    ],
  },
}
